import { DescriptionOutlined } from "@mui/icons-material";
import { ReactElement } from "react";
import { Link } from "react-router-dom";

export default function CollectionAssetEmpty(): ReactElement {
  return (
    <div className="w-full text-center">
      Current collection doesn't have assets. <br />
      Please go to files
      <Link to="/files">
        <DescriptionOutlined style={{ color: "#DD2127" }} className="mx-5" />
      </Link>
      and upload assets to this collection.
    </div>
  );
}
